import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CalendarCheck2, Store as StoreIcon, CheckCircle2, XCircle } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    const [recent, setRecent] = useState([]);

    const refresh = async () => {
        const [s, b] = await Promise.all([
            api.get("/admin/stats"),
            api.get("/admin/bookings"),
        ]);
        setStats(s.data);
        const sorted = [...b.data].sort((a, b) =>
            (b.created_at || "").localeCompare(a.created_at || ""),
        );
        setRecent(sorted.slice(0, 8));
    };

    useEffect(() => {
        refresh();
    }, []);

    const tiles = [
        { label: "Negozi attivi", value: stats?.total_stores ?? "—", icon: StoreIcon },
        { label: "Prenotazioni totali", value: stats?.total_bookings ?? "—", icon: CalendarCheck2 },
        { label: "Confermate", value: stats?.confirmed ?? "—", icon: CheckCircle2 },
        { label: "Annullate", value: stats?.cancelled ?? "—", icon: XCircle },
    ];

    return (
        <div>
            <div className="mb-8">
                <div className="overline mb-2">Backoffice</div>
                <h1 className="font-serif-display text-3xl sm:text-4xl text-magni-navy">
                    Dashboard
                </h1>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
                {tiles.map((t) => (
                    <div
                        key={t.label}
                        data-testid={`stat-${t.label}`}
                        className="bg-white border border-magni-light p-6"
                    >
                        <div className="flex items-center justify-between mb-3">
                            <span className="overline">{t.label}</span>
                            <t.icon className="w-5 h-5 text-magni-navy" />
                        </div>
                        <div className="font-serif-display text-4xl text-magni-navy">
                            {t.value}
                        </div>
                    </div>
                ))}
            </div>

            <div className="bg-white border border-magni-light">
                <div className="px-6 py-4 border-b border-magni-light flex items-center justify-between">
                    <h2 className="font-serif-display text-2xl text-magni-navy">
                        Prenotazioni recenti
                    </h2>
                    <Link
                        to="/admin/bookings"
                        className="text-xs uppercase tracking-[0.15em] font-semibold text-magni-navy hover:underline"
                    >
                        Vedi tutte →
                    </Link>
                </div>                {recent.length === 0 ? (
                    <div className="p-10 text-center text-magni-muted text-sm">
                        Nessuna prenotazione ancora ricevuta.
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-magni-cream text-magni-muted">
                                <tr>
                                    <th className="text-left px-6 py-3 font-medium">Data</th>
                                    <th className="text-left px-6 py-3 font-medium">Ora</th>
                                    <th className="text-left px-6 py-3 font-medium">Cliente</th>
                                    <th className="text-left px-6 py-3 font-medium">Negozio</th>
                                    <th className="text-left px-6 py-3 font-medium">Stato</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recent.map((b) => (
                                    <tr key={b.id} className="border-t border-magni-light">
                                        <td className="px-6 py-3 text-magni-navy">{b.slot_date}</td>
                                        <td className="px-6 py-3 text-magni-navy">{b.slot_time}</td>
                                        <td className="px-6 py-3 text-magni-navy">
                                            {b.first_name} {b.last_name}
                                        </td>
                                        <td className="px-6 py-3 text-magni-muted">{b.store_name}</td>
                                        <td className="px-6 py-3">
                                            <span
                                                className={`text-xs font-semibold uppercase tracking-wider px-2 py-1 ${
                                                    b.status === "confirmed"
                                                        ? "bg-green-50 text-green-700"
                                                        : b.status === "cancelled"
                                                          ? "bg-red-50 text-red-700"
                                                          : "bg-magni-light text-magni-muted"
                                                }`}
                                            >
                                                {b.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
